import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { ConnectionService } from 'ng-connection-service';
import { Observable, Subscription, timer } from 'rxjs';
import { delayWhen, map, retryWhen, take, tap } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';

@Component({
  selector: 'app-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.scss'],
  standalone: false,
})
export class ImportCsvComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  translationSubscription: Subscription;
  data$: Observable<any> = this.component.data$;
  files: any[] = [];
  uploading = false;
  fileName: string;
  isConnected = true;
  connectionFailed = false;
  uploadSuccess = false;
  errorText: string;
  importCartGlobalMsg: any;
  importCartGlobalFooterMsg: any;
  isFormatAccepted: any;
  uploadFileAcceptFormats: string[] = ['text/csv'];
  getLanguageSubscription: Subscription;

  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    public component: CmsComponentData<any>,
    private connectionService: ConnectionService,
    private cartService: CartExtendService,
    private translation: TranslationService,
    private cd: ChangeDetectorRef,
    private languageService: ShimanoLanguageService
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
    });
  }

  ngOnInit() {
    this.getLanguageSubscription = this.languageService.getActive().subscribe(() => {
      setTimeout(() => {
        this.importCartGlobalMsg = document.querySelector('.cart-import-alert');
      }, 2000);
    });
    this.importCartGlobalFooterMsg = document.querySelector('cx-global-message div');
    this.importCartGlobalFooterMsg.style.display = 'none';
  }
  fileBrowseHandler(event: any) {
    const files = event.target.files[0];
    if (this.isConnected) {
      this.uploading = true;
      this.fileName = files.name;
      this.importCartGlobalMsg.classList.add('active');
      this.subscription.add(
        this.cartService
          .postCsvImportFile(files)
          .pipe(take(1))
          .subscribe(
            (res: any) => {
              this.uploadSuccess = false;
              this.uploading = true;
              this.cartService
                .getCartProcessStatus(res.code, false)
                .pipe(
                  map((stat: any) => {
                    if (stat) {
                      if (stat.status === 'PROCESSING') {
                        throw stat;
                      } else {
                        this.uploadSuccess = true;
                        this.uploading = false;
                        this.importCartGlobalMsg.classList.remove('active');
                        this.cd.markForCheck();
                      }
                    }
                  }),
                  retryWhen((errors) =>
                    errors.pipe(
                      tap(),
                      delayWhen(() => timer(5000))
                    )
                  )
                )
                .subscribe();
              this.cd.markForCheck();
            },
            (err) => {
              this.translationSubscription?.unsubscribe();
              if (this.checkCSVFile(files)) {
                this.errorText = err.error.errors[0].message;
                this.connectionFailed = true;
                this.uploading = false;
                this.importCartGlobalMsg.classList.remove('active');
                this.cd.markForCheck();
              } else {
                this.isAccepted();
              }
            }
          )
      );
    } else {
      this.connectionFailed = true;
      this.importCartGlobalMsg.classList.remove('active');
    }
  }

  checkCSVFile(file: any) {
    var extension = file.name.substr(file.name.lastIndexOf('.') + 1);
    if (!/(csv)$/gi.test(extension)) {
      return false;
    }
    return true;
  }

  resetUpload() {
    this.isConnected = true;
    this.connectionFailed = false;
    this.uploadSuccess = false;
    this.uploading = false;
    this.importCartGlobalMsg.classList.remove('active');
  }

  isAccepted() {
    this.translationSubscription = this.translation.translate('csvImport.csvOnly').subscribe((csvOnly) => {
      this.errorText = csvOnly;
    });
    this.connectionFailed = true;
    this.uploading = false;
    this.importCartGlobalMsg.classList.remove('active');
    this.cd.markForCheck();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
    if (this.getLanguageSubscription) {
      this.getLanguageSubscription.unsubscribe();
    }
    this.importCartGlobalFooterMsg.style.display = 'block';
  }
}
